import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppLoginQueryCriteriaClass extends BaseCriteriaModel {
  // app_login_subject
  name?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();
  category?: Optional<string> = Optional.empty();

  // app_login_subject_ext
  extType?: Optional<string> = Optional.empty();
  extCode?: Optional<string> = Optional.empty();
  extOption?: Optional<string> = Optional.empty();
  paramCode?: Optional<string> = Optional.empty();
  paramName?: Optional<string> = Optional.empty();
  paramType?: Optional<string> = Optional.empty();
  valueString?: Optional<string> = Optional.empty();

  // app_login_principal
  principalType?: Optional<string> = Optional.empty();
  principalId?: Optional<string> = Optional.empty();
  principalStatus?: Optional<string> = Optional.empty();
}

export class AppLoginCriteriaModelQuery {
  query = '';

  constructor(appLoginCriteriaModel: AppLoginQueryCriteriaClass) {

    if (!appLoginCriteriaModel) {
      return;
    }

    this.query += appLoginCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += appLoginCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += appLoginCriteriaModel.category.filter(x => x !== '').map(x => '&category=' + x).orElse('');

    this.query += appLoginCriteriaModel.extType.filter(x => x !== '').map(x => '&extType=' + x).orElse('');
    this.query += appLoginCriteriaModel.extCode.filter(x => x !== '').map(x => '&extCode=' + x).orElse('');
    this.query += appLoginCriteriaModel.extOption.filter(x => x !== '').map(x => '&extOption=' + x).orElse('');
    this.query += appLoginCriteriaModel.paramCode.filter(x => x !== '').map(x => '&paramCode=' + x).orElse('');
    this.query += appLoginCriteriaModel.paramName.filter(x => x !== '').map(x => '&paramName=' + x).orElse('');
    this.query += appLoginCriteriaModel.paramType.filter(x => x !== '').map(x => '&paramType=' + x).orElse('');
    this.query += appLoginCriteriaModel.valueString.filter(x => x !== '').map(x => '&valueString=' + x).orElse('');

    this.query += appLoginCriteriaModel.principalType.filter(x => x !== '').map(x => '&principalType=' + x).orElse('');
    this.query += appLoginCriteriaModel.principalId.filter(x => x !== '').map(x => '&principalId=' + x).orElse('');
    this.query += appLoginCriteriaModel.principalStatus.filter(x => x !== '').map(x => '&principalStatus=' + x).orElse('');

    this.query += '&status=' + appLoginCriteriaModel.status;
    this.query += '&orderBy=' + appLoginCriteriaModel.orderBy;
    this.query += '&order=' + appLoginCriteriaModel.order;
    this.query += '&offset=' + appLoginCriteriaModel.offset + '&limit=' + appLoginCriteriaModel.limit;
  }
}
